<template>
  <b-btn size="sm" variant="outline-secondary" class="ml-2" id="add-defect">
    {{ $t('buttons.purchase_invoices.defect') }}
    <b-popover target="add-defect" placement="bottom" ref="add-defect-popover"
               :show.sync="show" @hidden="$emit('handleHidden')">
      <b-row>
        <b-col cols="8" class="pr-0">
          <label for="defectData.defect_value">
            {{ `${$t('labels.common.defect_value')}, %` }}
          </label>
          <input id="defectData.defect_value" class="form-control" v-model="defectData.defect_value">
        </b-col>
        <b-col cols="4" class="d-flex align-items-end">
          <multiselect v-model="defectData.defect_measurement" :max-height="200"
                       placeholder="" style="width: 60px"
                       :options="defectData.defect_measurements" :close-on-select="true"
                       select-label="" deselect-label="" selected-label=""></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label for="defectData.defect_price">
            {{ `${$t('labels.common.price_per_defect')}, ${base_currency.code}/m3 ` }}
          </label>
          <input id="defectData.defect_price" class="form-control" v-model="defectData.defect_price">
        </b-col>
      </b-row>
      <div class="row justify-content-center">
        <b-btn variant="success" size="sm" @click="add">
          {{ $t('buttons.common.add') }}
        </b-btn>
      </div>
    </b-popover>
  </b-btn>
</template>
<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

/**
 * currently a component for reducing complexity overload in PurchaseInvoice page
 *
 * this is a popover for defects on fact. evaluation tab.
 * emits: ['handleAdd', 'handleHidden']
 */
export default {
  name: 'WdDefectPopover',
  components: { Multiselect },
  data () {
    return {
      show: false,
      defectData: {
        defect_value: null,
        defect_price: null,
        defect_measurement: '%',
        defect_measurements: ['%']
      }
    }
  },
  computed: {
    ...mapState('woodware', ['base_currency'])
  },
  methods: {
    add () {
      this.$emit('handleAdd', {
        ...this.defectData,
        close: () => this.show = false
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/purchase-invoice/WdDefectPopover.vue